import axios from '../../plugins/axios'

export const sendEmail = (_, { data }) => {
  return axios.post('/api/utils/send-email', data)
    .catch(err => err.response)
}

export const sendF29 = (_, { data }) => {
  return axios.post('/api/webscraping/send-f29', data)
    .catch(err => err.response)
}

export const receiveDocuments = (_, { data }) => {
  return axios.post('/api/webscraping/receive-documents', data)
    .catch(err => err.response)
}
